import { TReduxActions } from '../../types/redux';
import { ENewQuestionModalStep, INewQuestion } from '../../types/newQuestion';
import {
  ENameActionTypes,
  ENewQuestionForm,
  EOpenNewQuestionForm,
  EQuestionTextTypes,
  EStepActionTypes,
  EAnonymousActionTypes,
} from '../../actions/newQuestion';

export const defaultNewQuestion = {
  isAnonymous: null,
  name: null,
  open: false,
  step: ENewQuestionModalStep.Question,
  text: '',
};

export const newQuestionReducer = (state: INewQuestion, action: TReduxActions): INewQuestion => {
  switch (action.type) {
    case ENameActionTypes.SetName: {
      return { ...state, name: action.payload };
    }
    case EOpenNewQuestionForm.Open: {
      return { ...state, open: false };
    }
    case EOpenNewQuestionForm.Close: {
      return { ...state, open: true };
    }
    case EStepActionTypes.Set: {
      return { ...state, step: action.payload };
    }
    case EQuestionTextTypes.Set: {
      return { ...state, text: action.payload };
    }
    case EAnonymousActionTypes.Set: {
      return { ...state, isAnonymous: action.payload };
    }

    case ENewQuestionForm.Clear:
    default: {
      return { ...defaultNewQuestion };
    }
  }
};
